export default __webpack_public_path__ + "static/media/hand-book.dc357fba.pdf";